module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/danny-800.ba3168225a04a2a5.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/danny-800.ba3168225a04a2a5.jpg",width: 800,height: 356}],
        src: "https://static.sniffspot.com/packs/img/danny-800.ba3168225a04a2a5.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/danny-800.ba3168225a04a2a5.jpg"},
        
        width: 800,
        height: 356
      }